import {
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';

type Props<T> = {
  key: string[];
  enabled?: boolean;
  fetchFn: (...params: any) => Promise<T>;
  defaultValue?: T;
};

export default function usePrefetchedData<T>({
  key,
  fetchFn,
  enabled,
}: Props<T>): UseQueryResult<T, Error> {
  return useQuery<T, Error>({
    queryKey: key,
    queryFn: fetchFn,
    gcTime: Infinity,
    enabled,
  });
}
